// Service data for the <strong>TISSA Technology</strong> website

export const services = [
  {
    id: "custom-software-development",
    title: "Custom Software Development",
    shortDescription:
      "We offer full IT services like Cryptocurrency App Development, IoT App Development, Software Development, Mobile Application Development, Web Development, Application Integrations and also work on many more new technologies to deliver the best for all businesses.",
    icon: "web-development",
    route: "/services/custom-software-development",
    image: "/assets/images/services/software-development.png",
    fullDescription: `
    <div class="text-justify">
        <p>We are a leading custom software development company, specialized in developing advanced solutions for enterprises, businesses and start-ups. Our experienced team of software developers deliver robust, secure and high performance web applications with intuitive UI/UX designs. As one of the leading software development services providers, we have expertise in building new, and upgrading existing software applications from scratch.</p>
        <br/>
        <p>With skilled resources, standardized processes, and advanced technologies we offer a wide array of software development services and solutions to help our clients implement the right software strategy. Our solutions are aimed at increasing the brand's reputation, profitability, and efficiency by creating solutions that can automate various business processes.</p>
        <br/>
        <p>With our depth of knowledge in diverse technologies and domains, we develop software solutions that are efficient, productive and excellent on performance and robustness. As custom software development company, we focus on developing customized applications that fulfill the specific business requirements for our clients. Our goal is to exceed client's expectations by going beyond software to provide best solutions that transform data into knowledge, enabling them to solve their problems.</p>
    </div>
      `,
    highlights: [
      "Enterprise Application Development",
      "Web Application Development",
      "Mobile Application Development",
      "API Development & Integration",
      "Custom Software Development",
      "Legacy Application Modernization",
    ],
    getInTouch: "Connect to Custom Software Development Community",
  },
  {
    id: "mobile-app-development",
    title: "Mobile Application Development",
    shortDescription:
      "We are the top Mobile App Development Company, known for its excellent quality. Also, we are one of the Fastest Growing Mobile App (Android / IOS) Development Companies in Texas, the USA.",
    icon: "web-development-5",
    route: "/services/mobile-app-development",
    image: "/assets/images/services/mobile-application-development.png",
    fullDescription: `
    <div class="text-justify">
        <p>We are the top Mobile App Development Company, known for its excellent quality. Also, we are one of the Fastest Growing Mobile App (Android / IOS) Development Companies in Texas, the USA. Android app development company, <strong>TISSA Technology</strong> allows custom, offshore android application development, app creation services, and enterprise mobility solutions, etc.</p>
        <br/>
        <p>Excellent mobile app development services are utilized to change your business processes to mobile platforms. Companies today are looking for a partner with expertise in mobile app development services for minimum viable applications or complex mobile applications with third-party integrations. We consolidate mobile technology with system applications and endeavour to convey value to our clients.</p>
        <br/>
        <p>We believe in tapping new markets and fulfilling the requirements of our clients with focused cross-platform mobile app development to drive user engagement and revenue. We are having mobile applications that are client-friendly mobile applications that make it simple for users to get to them from each mobile device. Our mobile development team involves developers with extensive experience with mobile application developers who are capable of making mobile app development services for iPads, iPhones, Android, and Windows devices. Sincerity combined with diligence makes our work stand apart from the rest.</p>
    </div>
         <h2 class="text-lg font-semibold text-blue-600 mt-6 mb-4">
                           Key Services:
                          </h2>
                          <ul class="list-disc grid grid-cols-1 px-8 gap-3 lg:grid-cols-1 text-gray-700">
                                  <li>
                                    Custom iOS & Android app development
                                  </li>
                                  <li>
                                   Cross-platform app development
                                  </li>
                                  <li>
                                  UI/UX design for mobile apps
                                  </li>
                                  <li>
                                  API integration & backend development
                                  </li>
                                  <li>
                                   App testing, deployment & maintenance
                                  </li>
                                </ul>

                                <div class="mt-8">
        <h2 class="text-lg text-blue-600 font-semibold mb-4">Technologies We Use:</h2>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="bg-white border rounded p-4 bg-gray-50">
            <h3 class="font-semibold mb-2">Native Development</h3>
            <ul class="list-disc pl-5 text-gray-700 space-y-1">
              <li>Swift, Objective-C (iOS), Kotlin, Java (Android)</li>
            </ul>
          </div>
          <div class="bg-white border rounded p-4 bg-gray-50">
            <h3 class="font-semibold mb-2">Cross-Platform</h3>
            <ul class="list-disc pl-5 text-gray-700 space-y-1">
              <li>Flutter, React Native, Xamarin</li>
            </ul>
          </div>
          <div class="bg-white border rounded p-4 bg-gray-50">
            <h3 class="font-semibold mb-2">Backend & APIs</h3>
            <ul class="list-disc pl-5 text-gray-700 space-y-1">
              <li>Node.js, Python, Java, PHP, GraphQL, REST APIs</li>
            </ul>
          </div>
           <div class="bg-white border rounded p-4 bg-gray-50">
            <h3 class="font-semibold mb-2">Cloud & DevOp</h3>
            <ul class="list-disc pl-5 text-gray-700 space-y-1">
              <li>AWS, Azure, Firebase, Docker, CI/CD</li>
            </ul>
          </div>
          
        </div>
      </div>
        <div class="mt-8">
                            <h2 class="text-lg text-blue-600 font-semibold mb-4">
                              Advantages:
                            </h2>
                            <div class="grid grid-cols-1 gap-4 bg-white border p-6 rounded-md">
                              <div class="flex items-start gap-4">
                                <span class="text-green-600 text-xl">✔</span>
                                <p>
                                  <strong>User-Centric Design</strong> – Engaging and intuitive mobile experiences
                                </p>
                              </div>
                              <div class="flex items-start gap-4">
                                <span class="text-green-600 text-xl">✔</span>
                                <p>
                                  <strong>High Performance</strong> – Fast, secure, and scalable applications
                                </p>
                              </div>
                              <div class="flex items-start gap-4">
                                <span class="text-green-600 text-xl">✔</span>
                                <p>
                                  <strong>Cross-Platform Reach</strong> – One app for multiple platforms
                                </p>
                              </div>
                              <div class="flex items-start gap-4">
                                <span class="text-green-600 text-xl">✔</span>
                                <p>
                                  <strong>Faster Time-to-Market</strong> – Agile development for quick delivery
                                </p>
                              </div>
                              <div class="flex items-start gap-4">
                                <span class="text-green-600 text-xl">✔</span>
                                <p>
                                  <strong>Business Growth</strong> – Apps aligned with your strategic goals
                                </p>
                              </div>
                            </div>
                          </div>
      `,
    // highlights: [
    //   "iPhone App Development",
    //   "Android App Development",
    //   "Cross-Platform Development",
    //   "Hybrid Mobile App Development",
    //   "Mobile App UI/UX Design",
    //   "App Testing & Quality Assurance",
    // ],
    getInTouch: "Connect to Mobile Application Development Community",
  },
  {
    id: "api-development",
    title: "API Development & Management",
    shortDescription:
      "From custom APIs and microservices to integrations and full lifecycle management, <strong>TISSA Technology</strong> delivers scalable, secure API solutions that drive digital transformation.",
    icon: "api-development",
    route: "/services/api-development",
    image: "/assets/images/services/api-development.jpeg",
    fullDescription: `
    <div class="mt-5">
            <div>
              <div>
                <h1 class="text-2xl text-gray-700 font-bold mt-10">
                  1. API Development
                </h1>

                <div class="mx-auto ms-6">
                  <div class="relative">
                    <!-- Stage 1 -->
                    <div class="flex items-start relative">
                      <div class="">
                        <h2 class="text-xl font-bold mb-4 mt-5">
                          A. Custom API Development
                        </h2>
                        <div class=" mb-4">
                          <p class="text-gray-700 mb-2">
                            <strong>
                              Tailored APIs that connect your business —
                              securely, seamlessly, and smartly.
                            </strong>
                          </p>
                          <p class="text-justify">
                            At <strong>TISSA Technology</strong>, we specialize
                            in creating APIs designed around your unique
                            business needs. Our solutions enable seamless
                            integration between diverse applications, systems,
                            and data sources — helping you automate workflows,
                            streamline operations, and accelerate innovation.
                          </p>
                        </div>
                      </div>
                    </div>

                    <!-- Stage 2 -->
                    <div class="flex items-start relative">
                      <div class="">
                        <h2 class="text-xl font-bold mb-4 mt-5">
                          B. Microservices Development
                        </h2>
                        <div class=" mb-4">
                          <p class="text-gray-700 mb-2 font-semibold">
                            Build agile, scalable, and resilient systems with
                            Microservices architecture.
                          </p>
                          <p class="text-justify">
                            At <strong>TISSA Technology</strong>, we help
                            businesses transition from monolithic systems to
                            modern, cloud-native architectures using
                            microservices development. Our expert teams design
                            and implement independent, loosely coupled services
                            that work together seamlessly — enabling faster
                            deployments, easy scalability, and better fault
                            isolation.
                          </p>

                          <h2 class="text-lg font-semibold text-blue-600 mt-6 mb-4">
                            What We Offer:
                          </h2>

                          <div class="grid gap-8 md:grid-cols-2">
                            <div class="grid grid-cols-1 gap-4">
                              <div class="bg-white border rounded p-4">
                                <h3 class="font-semibold mb-2">
                                  Microservices Architecture Design
                                </h3>
                                <ul class="list-disc pl-5 text-gray-700 space-y-1">
                                  <li>
                                    Design robust, domain-driven microservices
                                    aligned with business capabilities.
                                  </li>
                                  <li>
                                    Define clear service boundaries,
                                    communication protocols
                                    (REST/gRPC/Event-driven), and service
                                    discovery mechanisms.
                                  </li>
                                </ul>
                              </div>

                              <div class="bg-white border rounded p-4">
                                <h3 class="font-semibold mb-2">
                                  Microservices Development
                                </h3>
                                <ul class="list-disc pl-5 text-gray-700 space-y-1">
                                  <li>
                                    Develop lightweight, containerized services
                                    using technologies like Spring Boot,
                                    Node.js, .NET Core, Python, etc.
                                  </li>
                                  <li>
                                    Implement business logic as independent
                                    units that are easy to test, deploy, and
                                    manage.
                                  </li>
                                </ul>
                              </div>

                              <div class="bg-white border rounded p-4">
                                <h3 class="font-semibold mb-2">
                                  API Gateways & Service Communication
                                </h3>
                                <ul class="list-disc pl-5 text-gray-700 space-y-1">
                                  <li>
                                    Implement API gateways for request routing,
                                    load balancing, throttling, and
                                    authentication.
                                  </li>
                                  <li>
                                    Enable secure and reliable communication via
                                    REST, message queues (e.g., Kafka,
                                    RabbitMQ), or gRPC.
                                  </li>
                                </ul>
                              </div>

                              <div class="bg-white border rounded p-4">
                                <h3 class="font-semibold mb-2">
                                  Cloud-Native Deployment
                                </h3>
                                <ul class="list-disc pl-5 text-gray-700 space-y-1">
                                  <li>
                                    Deploy microservices on platforms like
                                    Kubernetes, Docker, AWS ECS/EKS, Azure AKS,
                                    or GCP.
                                  </li>
                                  <li>
                                    Ensure high availability, auto-scaling, and
                                    CI/CD with DevOps best practices.
                                  </li>
                                </ul>
                              </div>

                              <div class="bg-white border rounded p-4">
                                <h3 class="font-semibold mb-2">
                                  Security & Monitoring
                                </h3>
                                <ul class="list-disc pl-5 text-gray-700 space-y-1">
                                  <li>
                                    Integrate service-level authentication
                                    (OAuth2, JWT), rate-limiting, and audit
                                    logging.
                                  </li>
                                  <li>
                                    Real-time observability using tools like
                                    Prometheus, Grafana, ELK Stack, or Jaeger
                                    for distributed tracing.
                                  </li>
                                </ul>
                              </div>

                              <div class="bg-white border rounded p-4">
                                <h3 class="font-semibold mb-2">
                                  Monolith to Microservices Migration
                                </h3>
                                <ul class="list-disc pl-5 text-gray-700 space-y-1">
                                  <li>
                                    Step-by-step migration strategies for legacy
                                    systems to microservices.
                                  </li>
                                  <li>
                                    Minimize downtime and risk with a proven
                                    incremental migration approach.
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div class="max-w-xl border rounded z-50 bg-gray-300 mx-auto px-10 py-8">
                              <h2 class="text-xl md:text-3xl font-bold text-center text-blue-700 mb-12 leading-tight">
                                FIVE KEY STAGES IN CREATING APIs FROM SCRATCH
                              </h2>

                              <div class="relative border-l-2 border-black ml-6 space-y-8">
                                <!-- Stage 1 --> 
                                <div class="relative flex items-start">
                                  <div class="absolute -left-[25px] w-12 h-12 rounded-full bg-blue-900 text-white flex items-center justify-center text-xl font-bold z-10">
                                    1
                                  </div>
                                  <div class="absolute left-0 top-6 w-8 h-0.5 bg-blue-900"></div>
                                  <div class="bg-white rounded border px-4 py-3 ms-8">
                                    <h3 class="text-lg font-semibold">
                                      Define API Specifications
                                    </h3>
                                    <p class="text-gray-700">
                                      Identify the API’s purpose, endpoints,
                                      request/response formats, methods, and
                                      authentication needs. Use tools like
                                      OpenAPI or Postman.
                                    </p>
                                  </div>
                                </div>

                                <!-- Stage 2 -->
                                <div class="relative flex items-start">
                                  <div class="absolute -left-[25px] w-12 h-12 rounded-full bg-blue-400 text-white flex items-center justify-center text-xl font-bold z-10">
                                    2
                                  </div>
                                  <div class="absolute left-0 top-6 w-8 h-0.5 bg-blue-400"></div>
                                  <div class="bg-white rounded border px-4 py-3 ms-8">
                                    <h3 class="text-lg font-semibold">
                                      Design the API Architecture
                                    </h3>
                                    <p class="text-gray-700">
                                      Plan the structure, URI patterns,
                                      versioning, error handling, naming
                                      conventions, and security protocols.
                                      Utilize design tools such as Swagger
                                      Editor or API Blueprint.
                                    </p>
                                  </div>
                                </div>

                                <!-- Stage 3 -->
                                <div class="relative flex items-start">
                                  <div class="absolute -left-[25px] w-12 h-12 rounded-full bg-orange-400 text-white flex items-center justify-center text-xl font-bold z-10">
                                    3
                                  </div>
                                  <div class="absolute left-0 top-6 w-8 h-0.5 bg-orange-400"></div>
                                  <div class="bg-white rounded border px-4 py-3 ms-8">
                                    <h3 class="text-lg font-semibold">
                                      Develop the API
                                    </h3>
                                    <p class="text-gray-700">
                                      Write backend logic and connect to
                                      databases or services using frameworks
                                      like Express.js, Flask, Django REST, or
                                      Spring Boot.
                                    </p>
                                  </div>
                                </div>

                                <!-- Stage 4 -->
                                <div class="relative flex items-start">
                                  <div class="absolute -left-[25px] w-12 h-12 rounded-full bg-red-500 text-white flex items-center justify-center text-xl font-bold z-10">
                                    4
                                  </div>
                                  <div class="absolute left-0 top-6 w-8 h-0.5 bg-red-500"></div>
                                  <div class="bg-white rounded border px-4 py-3 ms-8">
                                    <h3 class="text-lg font-semibold">
                                      Test and Validate the API
                                    </h3>
                                    <p class="text-gray-700">
                                      Perform unit, integration, and performance
                                      tests. Validate data integrity and
                                      security using tools like Postman or
                                      Swagger Validator.
                                    </p>
                                  </div>
                                </div>

                                
                              </div>
                              <!-- Stage 5 -->
                                <div class="relative flex items-start mt-8">
                                  <div class="absolute -left-[0px] w-12 h-12 rounded-full bg-green-600 text-white flex items-center justify-center text-xl font-bold z-10">
                                    5
                                  </div>

                                  <div class="absolute left-6 -top-10 w-0.5 h-12 bg-black"></div>
                                  <div class="absolute left-6 top-6 w-[35px] h-0.5 bg-green-600"></div>

                                  <div class="bg-white rounded border px-4 py-3 ms-[58px]">
                                    <h3 class="text-lg font-semibold">
                                      Deploy and Monitor the API
                                    </h3>
                                    <p class="text-gray-700">
                                      Deploy to cloud platforms or containers.
                                      Use API gateways such as Apigee or AWS API
                                      Gateway to manage access and monitor
                                      performance.
                                    </p>
                                  </div>
                                </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Stage 3 -->
                    <div class="flex items-start relative">
                      <div class="">
                        <h2 class="text-xl font-bold mb-4 mt-5">
                          C. API Consulting and Strategy
                        </h2>
                        <div class=" mb-4">
                          <p class="text-gray-700 mb-2 font-semibold">
                            Drive digital transformation with a smart, scalable,
                            and secure API-first approach.
                          </p>
                          <p class="text-justify">
                            At <strong>TISSA Technology</strong>, we help
                            businesses develop a clear, future-proof API
                            strategy aligned with their digital goals. Whether
                            you're building new APIs, managing legacy systems,
                            or planning large-scale integration — our API
                            consulting services ensure you get the most value
                            from your technology ecosystem.
                          </p>

                          <h2 class="text-lg font-semibold text-blue-600 mt-6 mb-4">
                            Our API Consulting Services
                          </h2>

                          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div class="bg-white border rounded p-4 bg-gray-50">
                              <h3 class="font-semibold mb-2">
                                API Strategy & Roadmap
                              </h3>
                              <ul class="list-disc pl-5 text-gray-700 space-y-1">
                                <li>
                                  Assess current architecture and digital
                                  maturity.
                                </li>
                                <li>
                                  Define short-term and long-term API goals
                                  aligned with business objectives.
                                </li>
                                <li>
                                  Prioritize initiatives like API monetization,
                                  developer enablement, and internal reuse.
                                </li>
                              </ul>
                            </div>

                            <div class="bg-white border rounded p-4 bg-gray-50">
                              <h3 class="font-semibold mb-2">
                                API Architecture & Design
                              </h3>
                              <ul class="list-disc pl-5 text-gray-700 space-y-1">
                                <li>
                                  Design scalable, loosely coupled, and secure
                                  API architectures (REST, GraphQL, gRPC).
                                </li>
                                <li>
                                  Define API standards and governance
                                  (OpenAPI/Swagger, versioning, documentation).
                                </li>
                                <li>
                                  Recommend the right tech stack and tools for
                                  your API ecosystem.
                                </li>
                              </ul>
                            </div>

                            <div class="bg-white border rounded p-4 bg-gray-50">
                              <h3 class="font-semibold mb-2">
                                Legacy Modernization via APIs
                              </h3>
                              <ul class="list-disc pl-5 text-gray-700 space-y-1">
                                <li>
                                  Wrap legacy systems with modern APIs to expose
                                  key business functionalities.
                                </li>
                                <li>
                                  Enable phased modernization and integration
                                  with cloud-native services.
                                </li>
                              </ul>
                            </div>

                            <div class="bg-white border rounded p-4 bg-gray-50">
                              <h3 class="font-semibold mb-2">
                                API Security & Compliance
                              </h3>
                              <ul class="list-disc pl-5 text-gray-700 space-y-1">
                                <li>
                                  Implement robust security models: OAuth 2.0,
                                  JWT, API key management, rate-limiting, and
                                  encryption.
                                </li>
                                <li>
                                  Ensure regulatory compliance (GDPR, HIPAA, PCI
                                  DSS) through secure API design.
                                </li>
                              </ul>
                            </div>

                            <div class="bg-white border rounded p-4 bg-gray-50">
                              <h3 class="font-semibold mb-2">
                                API Lifecycle Management
                              </h3>
                              <ul class="list-disc pl-5 text-gray-700 space-y-1">
                                <li>
                                  Define and implement best practices for API
                                  development, testing, deployment, monitoring,
                                  and versioning.
                                </li>
                                <li>
                                  Setup API Management platforms like Apigee,
                                  AWS API Gateway, Azure API Management, Kong,
                                  etc.
                                </li>
                              </ul>
                            </div>

                            <div class="bg-white border rounded p-4 bg-gray-50">
                              <h3 class="font-semibold mb-2">
                                Developer Experience & API Portals
                              </h3>
                              <ul class="list-disc pl-5 text-gray-700 space-y-1">
                                <li>
                                  Design intuitive developer portals for API
                                  documentation, sandbox environments, and
                                  onboarding.
                                </li>
                                <li>
                                  Enable internal and external developer
                                  productivity with well-documented,
                                  self-service APIs.
                                </li>
                              </ul>
                            </div>
                          </div>

                          <div class="mt-8">
                            <h2 class="text-lg text-blue-600 font-semibold mb-4">
                              Why TISSA Technology?
                            </h2>
                            <div class="grid grid-cols-1 gap-4 bg-white border p-6 rounded-md">
                              <div class="flex items-start gap-4">
                                <span class="text-green-600 text-xl">✔</span>
                                <p>
                                  <strong>Strategic Thinking:</strong> We blend
                                  technology with business goals to deliver API
                                  strategies that scale.
                                </p>
                              </div>
                              <div class="flex items-start gap-4">
                                <span class="text-green-600 text-xl">✔</span>
                                <p>
                                  <strong>Cross-Domain Expertise:</strong> CRM,
                                  ERP, FinTech, E-commerce, Healthcare, AI, and
                                  more.
                                </p>
                              </div>
                              <div class="flex items-start gap-4">
                                <span class="text-green-600 text-xl">✔</span>
                                <p>
                                  <strong>Vendor-Neutral Approach:</strong> We
                                  recommend the best-fit solutions, not tied to
                                  any specific platform.
                                </p>
                              </div>
                              <div class="flex items-start gap-4">
                                <span class="text-green-600 text-xl">✔</span>
                                <p>
                                  <strong>End-to-End Engagement:</strong> From
                                  assessment and planning to implementation and
                                  optimization.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Stage 4 -->
                    <div class="flex items-start relative">
                      <div class="">
                        <h2 class="text-xl font-bold mb-4 mt-5">
                          D. API Integration
                        </h2>
                        <div class=" mb-4">
                          <p class="text-gray-700 mb-2 font-semibold">
                            Connect your systems. Streamline your operations.
                            Accelerate your growth.
                          </p>
                          <p class="text-justify">
                            At <strong>TISSA Technology</strong>, we provide
                            robust and secure API Integration Services that
                            connect your business applications, data sources,
                            and third-party platforms. Our solutions help
                            eliminate silos, automate workflows, and deliver
                            real-time data exchange — empowering smarter, faster
                            decision-making across your enterprise.
                          </p>

                          <h2 class="text-lg font-semibold text-blue-600 mt-6 mb-4">
                            What We Offer
                          </h2>

                          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div class="bg-white border rounded p-4 bg-gray-50">
                              <h3 class="font-semibold mb-2">
                                Third-Party API Integration
                              </h3>
                              <ul class="list-disc pl-5 text-gray-700 space-y-1">
                                <li>
                                  Seamless integration with platforms like
                                  Salesforce, SAP, Odoo, HubSpot, Shopify,
                                  Stripe, Twilio, and more.
                                </li>
                                <li>
                                  Pre-built connectors and custom integrations
                                  to fit unique business needs.
                                </li>
                              </ul>
                            </div>

                            <div class="bg-white border rounded p-4 bg-gray-50">
                              <h3 class="font-semibold mb-2">
                                System-to-System Integration
                              </h3>
                              <ul class="list-disc pl-5 text-gray-700 space-y-1">
                                <li>
                                  Enable real-time data exchange between
                                  internal systems (e.g., CRM, ERP, HRMS,
                                  Finance).
                                </li>
                                <li>
                                  Reduce manual effort and data duplication
                                  through automated workflows.
                                </li>
                              </ul>
                            </div>

                            <div class="bg-white border rounded p-4 bg-gray-50">
                              <h3 class="font-semibold mb-2">
                                Cloud & SaaS Integration
                              </h3>
                              <ul class="list-disc pl-5 text-gray-700 space-y-1">
                                <li>
                                  Integrate cloud platforms such as AWS, Azure,
                                  Google Cloud, Office 365, and Zoho.
                                </li>
                                <li>
                                  Connect your on-premise systems with modern
                                  SaaS apps for hybrid architecture.
                                </li>
                              </ul>
                            </div>

                            <div class="bg-white border rounded p-4 bg-gray-50">
                              <h3 class="font-semibold mb-2">
                                AI/ML & Data Integration
                              </h3>
                              <ul class="list-disc pl-5 text-gray-700 space-y-1">
                                <li>
                                  Integrate with AI models, analytics engines,
                                  and data lakes to power insights and
                                  automation.
                                </li>
                                <li>
                                  Build data pipelines that fetch, transform,
                                  and serve real-time data via APIs.
                                </li>
                              </ul>
                            </div>

                            <div class="bg-white border rounded p-4 bg-gray-50">
                              <h3 class="font-semibold mb-2">
                                Secure & Scalable Architecture
                              </h3>
                              <ul class="list-disc pl-5 text-gray-700 space-y-1">
                                <li>
                                  Use of API gateways and middleware to manage
                                  traffic, secure endpoints, and ensure uptime.
                                </li>
                                <li>
                                  OAuth 2.0, JWT, and role-based access controls
                                  for secure integrations.
                                </li>
                              </ul>
                            </div>

                            <div class="bg-white border rounded p-4 bg-gray-50">
                              <h3 class="font-semibold mb-2">
                                Monitoring & Maintenance
                              </h3>
                              <ul class="list-disc pl-5 text-gray-700 space-y-1">
                                <li>
                                  Real-time monitoring of API calls, error
                                  tracking, and performance optimization.
                                </li>
                                <li>
                                  Ongoing support to ensure stability,
                                  reliability, and scalability of integrated
                                  systems.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <br />
            <div class="">
              <h1 class="text-2xl text-gray-700 font-bold mb-5 mt-8">
                2. API Management
              </h1>
              <div class="mx-auto mt-5 ms-6">
                <div class="relative mt-5">
                  <p class="text-gray-700 mb-2 font-semibold space-y-10">
                    Secure, scale, and govern your APIs with confidence.
                  </p>
                  <p class="text-justify">
                    At <strong>TISSA Technology</strong>, we offer end-to-end
                    API Management Services to help organizations control how
                    their APIs are created, deployed, secured, consumed, and
                    monitored. Whether you’re building a single API or managing
                    a large ecosystem, our solutions ensure your APIs are
                    reliable, discoverable, and secure — all while maximizing
                    business agility.
                  </p>

                  <h2 class="text-lg font-semibold text-blue-600 mt-6 mb-4">
                    What We Offer
                  </h2>

                  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div class="bg-white border rounded p-4 bg-gray-50">
                      <h3 class="font-semibold mb-2">
                        API Lifecycle Management
                      </h3>
                      <ul class="list-disc pl-5 text-gray-700 space-y-1">
                        <li>
                          Full support across the API lifecycle — from design
                          and development to retirement.
                        </li>
                        <li>
                          Standardize how APIs are versioned, tested, published,
                          and deprecated.
                        </li>
                        <li>
                          Support for REST, SOAP, GraphQL, and event-driven
                          APIs.
                        </li>
                      </ul>
                    </div>

                    <div class="bg-white border rounded p-4 bg-gray-50">
                      <h3 class="font-semibold mb-2">
                        Security & Access Control
                      </h3>
                      <ul class="list-disc pl-5 text-gray-700 space-y-1">
                        <li>
                          Implement enterprise-grade security protocols: OAuth
                          2.0, JWT, API keys, rate limiting, IP whitelisting,
                          and encryption.
                        </li>
                        <li>
                          Protect sensitive data and ensure only authorized
                          consumers can access APIs.
                        </li>
                        <li>
                          Threat detection and policy enforcement to prevent
                          misuse and abuse.
                        </li>
                      </ul>
                    </div>

                    <div class="bg-white border rounded p-4 bg-gray-50">
                      <h3 class="font-semibold mb-2">Analytics & Monitoring</h3>
                      <ul class="list-disc pl-5 text-gray-700 space-y-1">
                        <li>
                          Real-time API usage analytics: monitor traffic,
                          response times, error rates, and consumer behavior.
                        </li>
                        <li>
                          Identify bottlenecks, optimize performance, and ensure
                          SLAs are met.
                        </li>
                        <li>
                          Integration with observability tools like ELK Stack,
                          Prometheus, Datadog, and Grafana.
                        </li>
                      </ul>
                    </div>

                    <div class="bg-white border rounded p-4 bg-gray-50">
                      <h3 class="font-semibold mb-2">
                        API Gateway Setup & Management
                      </h3>
                      <ul class="list-disc pl-5 text-gray-700 space-y-1">
                        <li>
                          Deploy and manage robust API gateways (e.g., AWS API
                          Gateway, Azure API Management, Apigee, Kong, WSO2).
                        </li>
                        <li>
                          Enable central control of API routing, throttling,
                          logging, and transformation.
                        </li>
                      </ul>
                    </div>

                    <div class="bg-white border rounded p-4 bg-gray-50">
                      <h3 class="font-semibold mb-2">
                        Developer Portal & Ecosystem Enablement
                      </h3>
                      <ul class="list-disc pl-5 text-gray-700 space-y-1">
                        <li>
                          Build branded developer portals with interactive
                          documentation (Swagger/OpenAPI).
                        </li>
                        <li>
                          Enable API subscription, onboarding, and sandbox
                          testing for internal or external developers.
                        </li>
                        <li>
                          Promote API reusability and foster an
                          innovation-driven development environment.
                        </li>
                      </ul>
                    </div>

                    <div class="bg-white border rounded p-4 bg-gray-50">
                      <h3 class="font-semibold mb-2">
                        Policy & Governance Framework
                      </h3>
                      <ul class="list-disc pl-5 text-gray-700 space-y-1">
                        <li>
                          Define rules for API naming conventions, documentation
                          standards, and compliance (GDPR, HIPAA, PCI).
                        </li>
                        <li>
                          Automate governance with approval workflows and access
                          auditing.
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div class="mt-8">
                    <h2 class="text-lg text-blue-600 font-semibold mb-4">
                      Why TISSA Technology?
                    </h2>
                    <div class="grid grid-cols-1 gap-4 bg-white border p-6 rounded-md">
                      <div class="flex items-start gap-4">
                        <span class="text-green-600 text-xl">✔</span>
                        <p>
                          <strong>Domain-driven strategy:</strong> Align API
                          management with your enterprise architecture.
                        </p>
                      </div>
                      <div class="flex items-start gap-4">
                        <span class="text-green-600 text-xl">✔</span>
                        <p>
                          <strong>Expertise in top platforms:</strong> Apigee,
                          AWS, Azure, MuleSoft, Kong, WSO2, and more.
                        </p>
                      </div>
                      <div class="flex items-start gap-4">
                        <span class="text-green-600 text-xl">✔</span>
                        <p>
                          <strong>Scalable & cloud-ready:</strong> Designed for
                          modern microservices and hybrid cloud environments.
                        </p>
                      </div>
                      <div class="flex items-start gap-4">
                        <span class="text-green-600 text-xl">✔</span>
                        <p>
                          <strong>Ongoing support:</strong> Continuous
                          improvement through analytics, feedback loops, and
                          usage insights.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
  `,
    // highlights: [
    //   "Custom RESTful & GraphQL API Development",
    //   "Microservices Architecture & Deployment",
    //   "Third-Party & System Integration",
    //   "API Security (OAuth2, JWT, Rate Limiting)",
    //   "API Strategy, Roadmap & Consulting",
    //   "API Lifecycle Management & Governance",
    //   "Developer Portals & Self-Service Onboarding",
    //   "API Gateways (Apigee, AWS, Kong, Azure)",
    //   "Monitoring, Analytics & Compliance",
    // ],
    getInTouch: "Connect to API Development & Management Community",
  },
  {
    id: "integration",
    title: "Integration",
    shortDescription:
      "Data integration involves a combination of data that is accumulated to a centralized system from several sources. The stored data in different sources are obtained using different technologies to show it in a unified view.",
    icon: "web-development-3",
    route: "/services/integration",
    image: "/assets/images/services/integration-1.png",
    fullDescription: `
<div class="mt-10">

  <div class="mx-auto">
    <div class="relative mt-5">
      <p class="text-gray-700 mb-2 font-semibold">
        Connect systems. Unify data. Streamline operations.
      </p>
      <p class="text-justify">
        At <strong>TISSA Technology</strong>, we offer comprehensive <strong>Integration as a Service (IaaS)</strong> to help organizations connect applications, data sources, and business processes across hybrid IT environments. Our integration solutions are platform-agnostic and tailored to your needs — from legacy modernization to next-gen API-led connectivity using industry-leading tools like <strong>MuleSoft</strong>, <strong>Boomi</strong>, and <strong>Paragon</strong>.
      </p>

      <h2 class="text-lg font-semibold mt-6 mb-4 text-blue-700">What We Deliver</h2>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <!-- Enterprise System Integration -->
        <div class="bg-white border rounded p-4 bg-gray-50">
          <h3 class="font-semibold mb-2">Enterprise System Integration</h3>
          <ul class="list-disc pl-5 text-gray-700 space-y-1">
            <li>Seamless connectivity between ERP (SAP, Oracle, Odoo), CRM (Salesforce, HubSpot), HRMS, Finance, and custom apps.</li>
            <li>Enable real-time data flow and reduce manual interventions.</li>
          </ul>
        </div>

        <!-- Intelligent API-Led Integration -->
        <div class="bg-white border rounded p-4 bg-gray-50">
          <h3 class="font-semibold mb-2">Intelligent API-Led Integration</h3>
          <ul class="list-disc pl-5 text-gray-700 space-y-1">
            <li>Leverage MuleSoft Anypoint Platform for API design, orchestration, and management.</li>
            <li>Use Boomi AtomSphere for rapid, low-code integration across cloud and on-prem systems.</li>
            <li>Utilize Paragon for fast and flexible SaaS integrations with pre-built connectors and onboarding flows.</li>
          </ul>
        </div>

        <!-- iPaaS Implementation -->
        <div class="bg-white border rounded p-4 bg-gray-50">
          <h3 class="font-semibold mb-2">iPaaS Implementation (Integration Platform as a Service)</h3>
          <ul class="list-disc pl-5 text-gray-700 space-y-1">
            <li>MuleSoft – API-first integration with enterprise-grade governance.</li>
            <li>Boomi – Low-code, drag-and-drop integrations for fast deployment.</li>
            <li>Paragon – Ideal for SaaS companies needing embedded integrations for customers.</li>
          </ul>
        </div>

        <!-- Data Synchronization & ETL Pipelines -->
        <div class="bg-white border rounded p-4 bg-gray-50">
          <h3 class="font-semibold mb-2">Data Synchronization & ETL Pipelines</h3>
          <ul class="list-disc pl-5 text-gray-700 space-y-1">
            <li>Build robust data pipelines to sync data across systems in real-time or batch.</li>
            <li>Clean, transform, and enrich data for analytics, reporting, or automation.</li>
          </ul>
        </div>

        <!-- Security, Governance & Monitoring -->
        <div class="bg-white border rounded p-4 bg-gray-50">
          <h3 class="font-semibold mb-2">Security, Governance & Monitoring</h3>
          <ul class="list-disc pl-5 text-gray-700 space-y-1">
            <li>Role-based access, tokenized authentication (OAuth2, SAML), encrypted data transfer.</li>
            <li>Centralized logging, monitoring, and exception handling for operational visibility.</li>
          </ul>
        </div>

        <!-- Integration Testing & Maintenance -->
        <div class="bg-white border rounded p-4 bg-gray-50">
          <h3 class="font-semibold mb-2">Integration Testing & Maintenance</h3>
          <ul class="list-disc pl-5 text-gray-700 space-y-1">
            <li>Automated and manual testing of all integration points.</li>
            <li>Proactive maintenance, change management, and performance tuning.</li>
          </ul>
        </div>
      </div>

      <div class="mt-8">
        <h2 class="text-lg text-blue-600 font-semibold mb-4">Our Integration Technology Expertise</h2>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="bg-white border rounded p-4 bg-gray-50">
            <h3 class="font-semibold mb-2">MuleSoft</h3>
            <ul class="list-disc pl-5 text-gray-700 space-y-1">
              <li>API-first integration using Anypoint Studio & Exchange.</li>
              <li>Ideal for large enterprises with complex workflows and API ecosystems.</li>
            </ul>
          </div>
          <div class="bg-white border rounded p-4 bg-gray-50">
            <h3 class="font-semibold mb-2">Boomi</h3>
            <ul class="list-disc pl-5 text-gray-700 space-y-1">
              <li>Fast, low-code iPaaS for businesses of all sizes.</li>
              <li>Supports prebuilt connectors and scalable data mapping.</li>
            </ul>
          </div>
          <div class="bg-white border rounded p-4 bg-gray-50">
            <h3 class="font-semibold mb-2">Paragon</h3>
            <ul class="list-disc pl-5 text-gray-700 space-y-1">
              <li>Built for product teams offering SaaS products.</li>
              <li>Enables customer-facing integrations with minimal engineering effort.</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="mt-8">
        <h2 class="text-lg text-blue-600 font-semibold mb-4">Why Choose TISSA Technology?</h2>
        <div class="grid grid-cols-1 gap-4 bg-white border p-6 rounded-md">
          <div class="flex items-start gap-4">
            <span class="text-green-600 text-xl">✔</span>
            <p><strong>Integration-first mindset:</strong> Deep understanding of business process orchestration.</p>
          </div>
          <div class="flex items-start gap-4">
            <span class="text-green-600 text-xl">✔</span>
            <p><strong>Cross-platform proficiency:</strong> MuleSoft Certified, Boomi Accredited, and Paragon Partners.</p>
          </div>
          <div class="flex items-start gap-4">
            <span class="text-green-600 text-xl">✔</span>
            <p><strong>From strategy to execution:</strong> Advisory, architecture, implementation, and support.</p>
          </div>
          <div class="flex items-start gap-4">
            <span class="text-green-600 text-xl">✔</span>
            <p><strong>Outcome-driven:</strong> Focus on business agility, reduced TCO, and faster time-to-value.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

      `,
    // highlights: [
    //   "API Integration",
    //   "ERP Integration",
    //   "CRM Integration",
    //   "E-commerce Integration",
    //   "Legacy System Integration",
    //   "Cloud Integration",
    // ],
    getInTouch: "Connect to Integration Community",
  },
  {
    id: "data-analytics",
    title: "Data Analytics",
    shortDescription:
      "Unlock insights and drive informed decisions with our data analytics services using industry-leading tools like Power BI and Tableau.",
    icon: "data-analytics",
    route: "/services/data-analytics",
    image: "/assets/images/services/data-analytics.png",
    fullDescription: `
<div class="mt-10">
  <div class="mx-auto ">
    <div class="relative mt-5">
      <p class="text-gray-700 mb-2 font-semibold">
        Turn your data into decisions with powerful, interactive dashboards and insights.
      </p>
      <p class="text-justify">
        At <strong>TISSA Technology</strong>, we deliver end-to-end <strong>Data Analytics as a Service (DAaaS)</strong> to help organizations unlock the full value of their data. Using leading BI platforms like <strong>Power BI</strong> and <strong>Tableau</strong>, we transform raw data into intuitive visualizations, real-time dashboards, and actionable insights — empowering better, faster business decisions.
      </p>

      <h2 class="text-lg font-semibold mt-6 mb-4 text-blue-600">What We Offer</h2>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <!-- Business Intelligence & Visualization -->
        <div class="bg-white border rounded p-4 bg-gray-50">
          <h3 class="font-semibold mb-2">Business Intelligence & Visualization</h3>
          <ul class="list-disc pl-5 text-gray-700 space-y-1">
            <li>Design and development of interactive dashboards tailored to KPIs, roles, and departments.</li>
            <li>Custom visualizations for sales, finance, operations, HR, supply chain, and more.</li>
            <li>Integration with multiple data sources (Excel, SQL, SAP, Salesforce, Odoo, cloud apps).</li>
          </ul>
        </div>

        <!-- Data Integration & Modeling -->
        <div class="bg-white border rounded p-4 bg-gray-50">
          <h3 class="font-semibold mb-2">Data Integration & Modeling</h3>
          <ul class="list-disc pl-5 text-gray-700 space-y-1">
            <li>Data extraction and transformation (ETL) from on-premise and cloud sources.</li>
            <li>Build unified data models and semantic layers for enterprise-wide reporting.</li>
            <li>Use of Power Query, DAX, Tableau Prep, and advanced SQL to cleanse and structure data.</li>
          </ul>
        </div>

        <!-- Self-Service Analytics Enablement -->
        <div class="bg-white border rounded p-4 bg-gray-50">
          <h3 class="font-semibold mb-2">Self-Service Analytics Enablement</h3>
          <ul class="list-disc pl-5 text-gray-700 space-y-1">
            <li>Empower business users with role-based access to explore their own insights.</li>
            <li>Implement governed self-service frameworks to maintain data accuracy and control.</li>
          </ul>
        </div>

        <!-- Real-Time & Scheduled Reporting -->
        <div class="bg-white border rounded p-4 bg-gray-50">
          <h3 class="font-semibold mb-2">Real-Time & Scheduled Reporting</h3>
          <ul class="list-disc pl-5 text-gray-700 space-y-1">
            <li>Set up automated refresh schedules and real-time dashboards with streaming data.</li>
            <li>Enable alerting and trigger-based workflows for business-critical thresholds.</li>
          </ul>
        </div>

        <!-- Advanced Analytics & Forecasting -->
        <div class="bg-white border rounded p-4 bg-gray-50">
          <h3 class="font-semibold mb-2">Advanced Analytics & Forecasting</h3>
          <ul class="list-disc pl-5 text-gray-700 space-y-1">
            <li>Incorporate trend analysis, what-if scenarios, forecasting, and predictive insights using AI/ML extensions.</li>
            <li>Integration with Azure Machine Learning, Python, and R for deeper analytics.</li>
          </ul>
        </div>

        <!-- Security & Governance -->
        <div class="bg-white border rounded p-4 bg-gray-50">
          <h3 class="font-semibold mb-2">Security & Governance</h3>
          <ul class="list-disc pl-5 text-gray-700 space-y-1">
            <li>Row-level security (RLS), user-based access controls, and secure publishing of dashboards.</li>
            <li>Workspace and content governance in Power BI Service and Tableau Server/Cloud.</li>
          </ul>
        </div>

        <!-- Performance Optimization -->
        <div class="bg-white border rounded p-4 bg-gray-50">
          <h3 class="font-semibold mb-2">Performance Optimization</h3>
          <ul class="list-disc pl-5 text-gray-700 space-y-1">
            <li>Optimize data models, DAX queries, and Tableau extracts for high-speed analytics.</li>
            <li>Best practices in dashboard design, query tuning, and mobile responsiveness.</li>
          </ul>
        </div>
      </div>

      <div class="mt-8">
        <h2 class="text-lg text-blue-600 font-semibold mb-4">Our Platform Expertise</h2>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="bg-white border rounded p-4 bg-gray-50">
            <h3 class="font-semibold mb-2">Power BI</h3>
            <ul class="list-disc pl-5 text-gray-700 space-y-1">
              <li>Microsoft ecosystem integration (Excel, Azure, Dynamics 365, SharePoint).</li>
              <li>Enterprise-wide deployment with Power BI Service, Premium, and Embedded.</li>
            </ul>
          </div>
          <div class="bg-white border rounded p-4 bg-gray-50">
            <h3 class="font-semibold mb-2">Tableau</h3>
            <ul class="list-disc pl-5 text-gray-700 space-y-1">
              <li>Pixel-perfect, interactive dashboards with advanced visualization capabilities.</li>
              <li>Deep integration with cloud platforms (AWS, GCP, Snowflake, Redshift, BigQuery).</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="mt-8">
        <h2 class="text-lg text-blue-600 font-semibold mb-4">Why Choose TISSA Technology?</h2>
        <div class="grid grid-cols-1 gap-4 bg-white border p-6 rounded-md">
          <div class="flex items-start gap-4">
            <span class="text-green-600 text-xl">✔</span>
            <p><strong>Expertise in multi-domain analytics:</strong> manufacturing, retail, healthcare, finance, CRM/ERP systems.</p>
          </div>
          <div class="flex items-start gap-4">
            <span class="text-green-600 text-xl">✔</span>
            <p><strong>Strong knowledge in data connectors, APIs, and custom visualizations.</strong></p>
          </div>
          <div class="flex items-start gap-4">
            <span class="text-green-600 text-xl">✔</span>
            <p><strong>End-to-end service:</strong> from data strategy and modeling to deployment and training.</p>
          </div>
          <div class="flex items-start gap-4">
            <span class="text-green-600 text-xl">✔</span>
            <p><strong>Proven experience with enterprise clients and SMBs</strong> across India and globally.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

  `,
    // highlights: [
    //   "Interactive Dashboards & Reports",
    //   "Custom Power BI & Tableau Solutions",
    //   "Data Integration from Multiple Sources",
    //   "Real-Time Reporting & Analytics",
    //   "KPI Tracking & Business Intelligence",
    //   "Data Cleaning, Modeling & Visualization",
    // ],
    getInTouch: "Connect to Data Analytics Community",
  },
  {
    id: "big-data",
    title: "Big Data Development",
    shortDescription:
      "Big Data relates to the large quantities of data which flow in from multiple data sources and have various formats. It is much more than a group of datasets with different formats, it is an important resource which can be used to get innumerable benefits.",
    icon: "data",
    route: "/services/big-data",
    image: "/assets/images/services/Big-Data-and-Analytics.png",
    fullDescription: `
<div class="mt-10">
  <div class="mx-auto">
    <div class="relative mt-5">
      <p class="text-gray-700 mb-2 font-semibold">Harness the Power of Data at Scale</p>
      <p class="text-justify">
        Transform your enterprise with data-driven insights powered by <strong>TISSA Technology’s</strong> end-to-end <strong>Big Data Services</strong>.
        From data ingestion to advanced analytics, we help businesses unlock value from structured, semi-structured, and unstructured data across cloud, on-premise, and hybrid environments.
      </p>

      <h2 class="text-lg font-semibold mt-6 mb-4 text-blue-700">What We Offer</h2>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">

        <div class="bg-white border rounded p-4 bg-gray-50">
          <h3 class="font-semibold mb-2">Data Ingestion & Processing</h3>
          <ul class="list-disc pl-5 text-gray-700 space-y-1">
            <li>Real-time and batch data ingestion using platforms like Apache Kafka, Flume, Sqoop, NiFi, and AWS Kinesis.</li>
            <li>Distributed data processing pipelines with Apache Spark, Hadoop, Databricks, and Flink.</li>
            <li>Support for diverse data sources including ERP, CRM, IoT, mobile apps, social media, logs, and APIs.</li>
          </ul>
        </div>

        <div class="bg-white border rounded p-4 bg-gray-50">
          <h3 class="font-semibold mb-2">Big Data Architecture Design</h3>
          <ul class="list-disc pl-5 text-gray-700 space-y-1">
            <li>Design of scalable and fault-tolerant big data architecture tailored to your workload.</li>
            <li>Cloud-native, hybrid, or on-premise models using AWS EMR, Azure HDInsight, GCP Dataproc, or Cloudera/Hortonworks.</li>
          </ul>
        </div>

        <div class="bg-white border rounded p-4 bg-gray-50">
          <h3 class="font-semibold mb-2">Data Lake Implementation</h3>
          <ul class="list-disc pl-5 text-gray-700 space-y-1">
            <li>Build centralized data lakes using Amazon S3, Azure Data Lake, Hadoop HDFS, or Delta Lake.</li>
            <li>Schema-on-read and metadata cataloging with Apache Hive, Glue, or Apache Atlas.</li>
            <li>Optimize storage and access control for performance and governance.</li>
          </ul>
        </div>

        <div class="bg-white border rounded p-4 bg-gray-50">
          <h3 class="font-semibold mb-2">ETL/ELT Pipeline Development</h3>
          <ul class="list-disc pl-5 text-gray-700 space-y-1">
            <li>Build and orchestrate ETL/ELT workflows using Apache Airflow, Talend, Informatica, or Azure Data Factory.</li>
            <li>Clean, enrich, and transform large volumes of raw data into analysis-ready formats.</li>
          </ul>
        </div>

        <div class="bg-white border rounded p-4 bg-gray-50">
          <h3 class="font-semibold mb-2">Advanced Analytics & AI/ML Integration</h3>
          <ul class="list-disc pl-5 text-gray-700 space-y-1">
            <li>Enable predictive analytics, recommendation engines, customer segmentation, and anomaly detection.</li>
            <li>Integrate with Spark MLlib, TensorFlow, PyTorch, AWS SageMaker, and other ML frameworks.</li>
            <li>Stream analytics and real-time decision-making with Apache Storm or Kafka Streams.</li>
          </ul>
        </div>

        <div class="bg-white border rounded p-4 bg-gray-50">
          <h3 class="font-semibold mb-2">Data Security & Governance</h3>
          <ul class="list-disc pl-5 text-gray-700 space-y-1">
            <li>Implement enterprise-grade data protection: encryption at rest and in transit, RBAC, and audit trails.</li>
            <li>Metadata management, lineage tracking, and data quality frameworks.</li>
            <li>Compliance with GDPR, HIPAA, and other data regulations.</li>
          </ul>
        </div>

        <div class="bg-white border rounded p-4 bg-gray-50">
          <h3 class="font-semibold mb-2">Visualization & Reporting</h3>
          <ul class="list-disc pl-5 text-gray-700 space-y-1">
            <li>Connect processed big data to BI tools like Power BI, Tableau, Superset, and Looker.</li>
            <li>Build scalable dashboards and reports to deliver insights to business users in real-time.</li>
          </ul>
        </div>

      </div>

      <div class="mt-8">
        <h2 class="text-lg text-blue-600 font-semibold mb-4">Why TISSA Technology?</h2>
        <div class="grid grid-cols-1 gap-4 bg-white border p-6 rounded-md">
          <div class="flex items-start gap-4"><span class="text-green-600 text-xl">✔</span><p>Expertise in end-to-end Big Data ecosystems across multiple industries.</p></div>
          <div class="flex items-start gap-4"><span class="text-green-600 text-xl">✔</span><p>Cloud proficiency with AWS, Azure, GCP, and hybrid environments.</p></div>
          <div class="flex items-start gap-4"><span class="text-green-600 text-xl">✔</span><p>Skilled data engineers, architects, and scientists with enterprise-scale experience.</p></div>
          <div class="flex items-start gap-4"><span class="text-green-600 text-xl">✔</span><p>Proven delivery of high-performance, cost-effective, and secure platforms.</p></div>
          <div class="flex items-start gap-4"><span class="text-green-600 text-xl">✔</span><p>Seamless integration with ERP, CRM, IoT, AI/ML, and business applications.</p></div>
        </div>
      </div>

      <div class="mt-8">
        <h2 class="text-lg text-blue-600 font-semibold mb-4">Key Use Cases We Support</h2>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 bg-white border p-6 rounded-md font-semibold">
          <p><span class="text-green-600 mr-4">❯</span> Customer 360° and personalization</p>
          <p><span class="text-green-600 mr-4">❯</span> Predictive maintenance and IoT analytics</p>
          <p><span class="text-green-600 mr-4">❯</span> Fraud detection and real-time risk scoring</p>
          <p><span class="text-green-600 mr-4">❯</span> Supply chain optimization</p>
          <p><span class="text-green-600 mr-4">❯</span> Social media sentiment analysis</p>
          <p><span class="text-green-600 mr-4">❯</span> Clickstream and behavioral analytics</p>
        </div>
      </div>

      <div class="bg-blue-50 border border-blue-100 rounded-lg p-6 mt-6">
        <h3 class="text-lg font-semibold text-blue-900 mb-2">
          Ready to make smarter, faster, and data-driven decisions?
        </h3>
        <p class="text-gray-700 mb-4">
          👉 <a class="text-blue-700 font-bold ms-2 hover:underline" href="/contact-us/">Partner with TISSA Technology</a> for scalable Big Data solutions built for the future.
        </p>
      </div>

    </div>
  </div>
</div>
`,
    // highlights: [
    //   "Big Data Consulting",
    //   "Data Analytics",
    //   "Hadoop Implementation",
    //   "Data Warehousing",
    //   "Business Intelligence",
    //   "Predictive Analytics",
    // ],
    getInTouch: "Connect to Big Data Development Community",
  },
  {
    id: "ai-ml-genai",
    title: "AI, ML & Generative AI",
    shortDescription:
      "Empowering innovation with cutting-edge AI, Machine Learning, and Generative AI solutions that automate processes, enhance decision-making, and unlock new digital experiences.",
    icon: "ai-icon",
    route: "/services/ai-ml-genai",
    image: "/assets/images/services/ai-ml-genai.jpg",
    fullDescription: `
   <div class="mt-10">
  <div class="mx-auto">
    <div class="relative mt-5">
      <p class="text-gray-700 mb-2 font-semibold">Accelerate Innovation with Intelligent Technologies.</p>
      <p class="text-justify">
        <strong>TISSA Technology</strong> empowers businesses to harness the full potential of 
        <strong>Artificial Intelligence (AI)</strong>, <strong>Machine Learning (ML)</strong>, and 
        <strong>Generative AI</strong> to solve complex problems, automate operations, and unlock new growth opportunities.<br/> 
        We deliver cutting-edge solutions built on robust data, advanced models, and scalable infrastructure — turning ideas into intelligent, production-ready systems.
      </p>

      <h2 class="text-lg font-semibold mt-6 mb-4 text-blue-700">
        What We Offer
      </h2>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="bg-white border rounded p-4 bg-gray-50">
          <h3 class="font-semibold mb-2">AI & ML Model Development</h3>
          <ul class="list-disc pl-5 text-gray-700 space-y-1">
            <li>Supervised, unsupervised, and reinforcement learning models tailored to your business needs.</li>
            <li>End-to-end pipeline from data collection, cleaning, and feature engineering to model training, testing, and deployment.</li>
            <li>Classification, regression, clustering, anomaly detection, recommendation systems, forecasting, and more.</li>
          </ul>
        </div>

        <div class="bg-white border rounded p-4 bg-gray-50">
          <h3 class="font-semibold mb-2">MLOps & Model Lifecycle Management</h3>
          <ul class="list-disc pl-5 text-gray-700 space-y-1">
            <li>Streamlined model development and deployment using MLOps best practices.</li>
            <li>Toolchains include MLflow, DVC, Kubeflow, Airflow, and CI/CD for ML.</li>
            <li>Model monitoring, retraining, versioning, and governance.</li>
          </ul>
        </div>

        <div class="bg-white border rounded p-4 bg-gray-50">
          <h3 class="font-semibold mb-2">Generative AI Solutions</h3>
          <ul class="list-disc pl-5 text-gray-700 space-y-1">
            <li>Custom solutions using Large Language Models (LLMs) like GPT-4, Claude, LLaMA, Gemini, and open-source models (Mistral, Falcon, etc.).</li>
            <li>Build conversational AI, document summarizers, content generators, assistants, copilots, and knowledge bases.</li>
            <li>Fine-tuning, embedding generation, vector databases (e.g., Pinecone, FAISS, Weaviate), and RAG (Retrieval-Augmented Generation) frameworks.</li>
          </ul>
        </div>

        <div class="bg-white border rounded p-4 bg-gray-50">
          <h3 class="font-semibold mb-2">Conversational AI & Intelligent Agents</h3>
          <ul class="list-disc pl-5 text-gray-700 space-y-1">
            <li>Develop chatbots and voice assistants integrated with your CRM, ERP, HR, or support systems.</li>
            <li>Platforms: Dialogflow, Microsoft Bot Framework, Rasa, LangChain, OpenAI APIs.</li>
            <li>Use cases: customer service automation, HR agents, IT support bots, internal search copilots.</li>
          </ul>
        </div>

        <div class="bg-white border rounded p-4 bg-gray-50">
          <h3 class="font-semibold mb-2">Predictive & Prescriptive Analytics</h3>
          <ul class="list-disc pl-5 text-gray-700 space-y-1">
            <li>Build intelligent systems that forecast trends, customer behaviors, or operational risks.</li>
            <li>Combine statistical models and machine learning algorithms for actionable business decisions.</li>
          </ul>
        </div>

        <div class="bg-white border rounded p-4 bg-gray-50">
          <h3 class="font-semibold mb-2">Document AI & Intelligent Automation</h3>
          <ul class="list-disc pl-5 text-gray-700 space-y-1">
            <li>Automate data extraction, document processing, and classification using NLP and computer vision.</li>
            <li>Integrations with Power Automate, UiPath, ABBYY, Azure Cognitive Services.</li>
          </ul>
        </div>

        <div class="bg-white border rounded p-4 bg-gray-50">
          <h3 class="font-semibold mb-2">Custom AI Integrations</h3>
          <ul class="list-disc pl-5 text-gray-700 space-y-1">
            <li>Embed AI features into existing business applications or workflows.</li>
            <li>API-based integrations with tools like Salesforce Einstein, SAP AI Core, Dynamics AI, and custom web apps.</li>
          </ul>
        </div>
      </div>

      <div class="mt-8">
        <h2 class="text-lg text-blue-600 font-semibold mb-4">
          Use Cases We Deliver
        </h2>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 bg-white border font-semibold rounded p-6">
          <div class="flex items-start space-x-2"><span class="text-green-600 mr-3">❯</span><span>Lead scoring and churn prediction</span></div>
          <div class="flex items-start space-x-2"><span class="text-green-600 mr-3">❯</span><span>Inventory demand forecasting</span></div>
          <div class="flex items-start space-x-2"><span class="text-green-600 mr-3">❯</span><span>AI-powered CRM copilots</span></div>
          <div class="flex items-start space-x-2"><span class="text-green-600 mr-3">❯</span><span>Personalized marketing and recommendations</span></div>
          <div class="flex items-start space-x-2"><span class="text-green-600 mr-3">❯</span><span>Intelligent document summarization and Q&A</span></div>
          <div class="flex items-start space-x-2"><span class="text-green-600 mr-3">❯</span><span>Chatbots for HR, support, and IT services</span></div>
          <div class="flex items-start space-x-2"><span class="text-green-600 mr-3">❯</span><span>Fraud detection and credit scoring</span></div>
          <div class="flex items-start space-x-2"><span class="text-green-600 mr-3">❯</span><span>Image and video analysis for quality inspection</span></div>
        </div>
      </div>

      <div class="mt-8">
        <h2 class="text-lg text-blue-600 font-semibold mb-4">
          Tools & Technologies
        </h2>
        <div class="grid grid-cols-1 gap-3 bg-white border rounded p-6">
          <div class="flex items-start space-x-2"><span class="text-green-600 mr-3 text-2xl">⚙</span><span class="mt-1">Languages & Frameworks: Python, PyTorch, TensorFlow, Scikit-learn, Keras, Hugging Face</span></div>
          <div class="flex items-start space-x-2"><span class="text-green-600 mr-3 text-2xl">⚙</span><span class="mt-1">Platforms: Azure ML, AWS SageMaker, GCP Vertex AI, Databricks</span></div>
          <div class="flex items-start space-x-2"><span class="text-green-600 mr-3 text-2xl">⚙</span><span class="mt-1">LLM Ecosystem: OpenAI, LangChain, Vector DBs (Pinecone, FAISS), Prompt Engineering</span></div>
          <div class="flex items-start space-x-2"><span class="text-green-600 mr-3 text-2xl">⚙</span><span class="mt-1">NLP & Vision: spaCy, NLTK, Tesseract, OpenCV, YOLO</span></div>
        </div>
      </div>

      <div class="mt-8">
        <h2 class="text-lg text-blue-600 font-semibold mb-4">
          Why Choose TISSA Technology?
        </h2>
        <div class="grid grid-cols-1 gap-4 bg-white border p-6 rounded-md">
          <div class="flex items-start gap-4"><span class="text-green-600 text-xl">✔</span><p>Deep expertise across AI/ML/GenAI lifecycle</p></div>
          <div class="flex items-start gap-4"><span class="text-green-600 text-xl">✔</span><p>Cloud-native and enterprise-ready solutions</p></div>
          <div class="flex items-start gap-4"><span class="text-green-600 text-xl">✔</span><p>Experienced data scientists and ML engineers</p></div>
          <div class="flex items-start gap-4"><span class="text-green-600 text-xl">✔</span><p>Fast prototyping and production-grade delivery</p></div>
          <div class="flex items-start gap-4"><span class="text-green-600 text-xl">✔</span><p>Focus on privacy, security, and model governance</p></div>
        </div>
      </div>

      <div class="bg-blue-50 border border-blue-100 rounded-lg p-6 mt-6">
        <h3 class="text-lg font-semibold text-blue-900 mb-2">
          Reimagine your business with AI-driven transformation
        </h3>
        <p class="text-gray-700 mb-4">
          👉 <a class="text-blue-700 font-bold ms-2 hover:underline" href="/contact-us/">
            Partner with TISSA Technology
          </a> to design, develop, and scale your AI & GenAI journey.
        </p>
      </div>
    </div>
  </div>
</div>

  `,
    // highlights: [
    //   "Custom AI & ML Model Development",
    //   "Predictive Analytics & Forecasting",
    //   "Natural Language Processing (NLP)",
    //   "Generative AI (Chatbots, Content, Code)",
    //   "Computer Vision & Image Recognition",
    //   "AI Integration with Web & Mobile Apps",
    // ],
    getInTouch: "Connect to AI, ML & Generative AI Community",
  },
  {
    id: "sap-services",
    title: "SAP Services",
    shortDescription:
      "We provide comprehensive SAP consulting, implementation, integration, migration, and support services to help businesses optimize their operations and achieve digital transformation through SAP solutions.",
    icon: "sap-services",
    route: "/services/sap-services",
    image: "/assets/images/services/sap.jpeg",
    fullDescription: `
    <div class="text-justify">
        <p>We offer end-to-end SAP services designed to help organizations streamline their processes, improve efficiency, and gain real-time insights. Our SAP experts work closely with clients to design, implement, and optimize SAP solutions tailored to their specific business needs, enabling them to achieve operational excellence.</p>
        <br/>
        <p>From SAP implementation and integration to upgrades and ongoing support, we provide a full spectrum of SAP services. Our approach ensures that your SAP systems are fully aligned with your business objectives, delivering maximum value and ROI.</p>
        <br/>
        <p>With our in-depth knowledge of SAP modules, industry best practices, and modern technologies, we help businesses harness the power of SAP to drive growth, agility, and innovation. Whether you are looking to migrate to SAP S/4HANA, integrate SAP with other enterprise systems, or enhance existing SAP capabilities, we are your trusted partner for all things SAP.</p>
    </div>
      `,
    highlights: [
      "SAP Implementation & Configuration",
      "SAP S/4HANA Migration & Upgrade",
      "SAP Module Integration (FI, CO, MM, SD, PP, etc.)",
      "Custom SAP Development",
      "SAP Business Process Optimization",
      "Ongoing SAP Support & Maintenance",
    ],
    subServices: [
      {
        id: "sap-successfactors",
        title: "Success Factors",
        description:
          "Full-cycle implementation of SuccessFactors modules based on SAP Activate methodology.",
      },
      {
        id: "sap-btp",
        title: "Business Technology Platform",
        description:
          "Automate and orchestrate workflows using SAP Workflow Management and Business Rules Service.",
      },
    ],
    getInTouch: "Connect to SAP Community",
  },
  {
    id: "odoo-services",
    title: "Odoo Services",
    shortDescription:
      "At <strong>TISSA Technology</strong>, we are committed to delivering exceptional Odoo services tailored to meet your business needs. Our team of experts is dedicated to helping you optimize your operations, improve efficiency, and drive growth with the robust capabilities of Odoo.",
    icon: "web-development-4",
    route: "/services/odoo-services",
    image: "/assets/images/services/odoo-services.png",
    fullDescription: `
    <div class="text-justify">
        <p>At <strong>TISSA Technology</strong>, we are committed to delivering exceptional Odoo services tailored to meet your business needs. Our team of experts is dedicated to helping you optimize your operations, improve efficiency, and drive growth with the robust capabilities of Odoo.</p>
        <br/>
        <p>Odoo is a comprehensive suite of business applications including CRM, e-Commerce, accounting, inventory, point of sale, project management, etc. Odoo helps to efficiently run your business by seamlessly automating processes and connecting your different departments. Being a top Odoo development company, we provide all-inclusive Odoo development services to simplify your complex business operations.</p>
        <br/>
        <p>Our Odoo experts can help you with implementation, integration, customization, support & maintenance, migration, and consultation. We work closely with your team to understand your unique business requirements and provide tailored solutions that align with your goals.</p>
    </div>
      `,
    highlights: [
      "Odoo Implementation",
      "Odoo Customization",
      "Odoo ERP Development",
      "Odoo Integration",
      "Odoo Support & Maintenance",
      "Odoo Migration & Upgrades",
    ],
    subServices: [
      {
        id: "odoo-integration",
        title: "Odoo Integration",
        description:
          "Seamlessly connect Odoo with your existing systems and third-party applications.",
      },
      {
        id: "odoo-implementation",
        title: "Odoo Implementation",
        description:
          "End-to-end Odoo implementation services tailored to your business needs.",
      },
      {
        id: "odoo-customization",
        title: "Odoo Customization",
        description:
          "Custom Odoo development to modify or extend standard functionalities.",
      },
      {
        id: "erp-development",
        title: "Odoo ERP Development",
        description:
          "Comprehensive ERP solutions using Odoo for optimized business processes.",
      },
      {
        id: "offshore-development",
        title: "Odoo Offshore Development",
        description:
          "Cost-effective offshore Odoo development services with dedicated teams.",
      },
      {
        id: "odoo-cunsultation",
        title: "Odoo Consultation and Analysis",
        description:
          "Expert guidance and analysis for optimal Odoo implementation and usage.",
      },
      {
        id: "odoo-support-maintenance",
        title: "Odoo Support & Maintenance",
        description:
          "Ongoing support and maintenance to ensure smooth operation of your Odoo system.",
      },
      {
        id: "odoo-migration",
        title: "Odoo Migration",
        description:
          "Seamless migration from legacy systems or older Odoo versions to newer versions.",
      },
      {
        id: "odoo-upgrades",
        title: "Odoo Upgrades",
        description:
          "Upgrade your existing Odoo installation to the latest version with minimal disruption.",
      },
    ],
    getInTouch: "Connect to Odoo Community",
  },
  {
    id: "consulting",
    title: "Consulting",
    shortDescription:
      "Use the deep tech background and the team of our best minds at <strong>TISSA Technology</strong> to develop a whole IT approach for a digital and technological transformation of your organization that goes in line with your business objectives.",
    icon: "customer-service",
    route: "/services/consulting",
    image: "/assets/images/services/consulting.jpeg",
    fullDescription: `
        <div class="text-justify">
        <p>Leverage the deep tech expertise and top talent at <strong>TISSA Technology</strong> to develop a comprehensive IT strategy that drives digital transformation in alignment with your business objectives. Our strategic IT consulting team helps organizations understand and implement disruptive technologies, adopt agile design principles, and approach digital innovation with a clear, strategic focus.</p>
        <br/>
        <p>Taking a holistic view, we help define, design, and execute strategies that optimize cost and quality while unlocking new revenue streams. As one of the leading IT consulting firms, we are dedicated to delivering measurable business outcomes through innovative solutions.</p>
        <br/>
        <p>Recognized as a top IT consulting firm, <strong>TISSA Technology</strong> combines cutting-edge solutions with deep domain expertise to craft both short- and long-term strategies tailored to your enterprise goals, IT landscape, talent needs, and compliance requirements.</p>
        <br/>
        <p><strong>TISSA Technology</strong> is your trusted partner for IT consulting services. Our expertise spans multiple domains, delivering custom-tailored consulting solutions to organizations of all sizes. With us by your side, you gain access to efficient IT strategies and forward-thinking solutions that accelerate your business growth</p>
        </div>
      `,
    highlights: [
      "IT Strategy Consulting",
      "Technology Assessment",
      "Digital Transformation",
      "IT Architecture Design",
      "Process Optimization",
      "IT Roadmap Development",
    ],
    getInTouch: "Get in touch",
  },
];

export default services;
